import React from 'react';
import getText, { HtmlParser } from 'AppUtils/language';

import "../TextPages.scss";

const TermsComponent = (props) => {
    return (
        <div className="text-pages tos-component">
            <h1>{getText("tos[text_title]")}</h1>
			<HtmlParser html="tos[text_content]" />
        </div>
    );
}

export default TermsComponent;
